import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SensorsModuleComponent} from './sensors-module.component';
import {SensorDashboardViewComponent} from './views/sensor-dashboard-view/sensor-dashboard-view.component';
import {SensorListViewComponent} from './views/sensor-list-view/sensor-list-view.component';
import {SensorsAuthorizedGuard} from "./guards/sensors-authorized.guard";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SensorListComponent} from './components/sensor-list/sensor-list.component';
import {SensorService} from "./services/sensor.service";
import {SensorDetailsComponent} from './views/sensor-details/sensor-details.component';
import {TemperatureLogEntriesListComponent} from './components/temperature-log-entries-list/temperature-log-entries-list.component';
import {TemperatureLogChartComponent} from './components/temperature-log-chart/temperature-log-chart.component';
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {SensorFormComponent} from './components/sensor-form/sensor-form.component';
import {OrganizationModule} from "../organization/organization.module";
import {CollapseModule} from 'ngx-bootstrap/collapse';

@NgModule({
  imports: [
    CommonModule, BrowserAnimationsModule, FormsModule, ReactiveFormsModule, RouterModule,
    CollapseModule.forRoot(),
    NgxChartsModule,
    VisbosCoreModule, OrganizationModule
  ],
  providers: [SensorsAuthorizedGuard, SensorService],
  declarations: [SensorsModuleComponent, SensorDashboardViewComponent, SensorListViewComponent, SensorListComponent, SensorDetailsComponent, TemperatureLogEntriesListComponent, TemperatureLogChartComponent, SensorFormComponent]
})
export class SensorsModule {
}



// WEBPACK FOOTER //
// ./src/app/sensors/sensors.module.ts